import { mapActions, mapMutations } from 'vuex'
import Modal from '@/components/modals/modal/modal.vue'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import ShowTMCModal from '@/components/modals/tmc-courier-data-modal/tmc-courier-data-modal.vue'
import SendToGainModal from '@/components/modals/send-to-gain-modal/send-to-gain-modal.vue'
import FuelFormModal from '@/components/modals/fuel-form-modal/fuel-form-modal.vue'
import FilterSelect from '@/components/filters-select/filters-select.vue'
import CurrencyFormatInput from '@/components/currency-format-input/currency-format-input.vue'
import Scrollbar from '@/components/scrollbar/scrollbar.vue'
import CourierDetailShift from '@/components/courier-detail-shift/courier-detail-shift.vue'
import Loader from '@/components/loader/loader.vue'
import IcEdit from '@/assets/svg/ic-edit.svg?inline'
import IcPlus from '@/assets/svg/ic-plus.svg?inline'
import IcArrowExpand from '@/assets/svg/ic-arrow-expand.svg?inline'
import IcBox from '@/assets/svg/ic-box-packed.svg?inline'

import { numberWithSeparator } from '@/utils/format-strings'

export default {
  name: 'CourierDetailModal',
  components: {
    Modal,
    ValidationObserver,
    ValidationProvider,
    SendToGainModal,
    ShowTMCModal,
    FuelFormModal,
    FilterSelect,
    CurrencyFormatInput,
    Scrollbar,
    CourierDetailShift,
    Loader,
    IcEdit,
    IcPlus,
    IcArrowExpand,
    IcBox
  },

  props: {
    courierId: {
      type: String | Number
    },
    current: {
      type: Boolean,
      default: false
    }
  },

  data() {
    const courierTypeOptions = [
      {
        id: 0,
        title: 'Велокурьер'
      },
      {
        id: 1,
        title: 'Водитель'
      }
    ]
    return {
      /**Получаемая информация о курьере */

      /**
       * {
       *   photo,
       *   name,
       *   shiftTimes - Array или String, -
       *   phone
       * }
       *
       */
      courierInfo: null,
      shifts: [],
      fuelMoneyInfo: null,
      shiftPhotos: [],

      /**Конец получаемой информации о курьере */

      courierType: courierTypeOptions[0],
      courierTypeOptions,
      patchPending: false,
      expandedFuelTable: false,
      showCurrentShiftFuelForm: false,
      currentShift: null,
      /**
       * будет отформатированная строка,
       * при помощи регуряного выражения при отправке
       * вытащим из нее число
       */
      currentShiftFuelSumm: 0,
      editableFuelTransaction: null
    }
  },

  computed: {
    commonFuelMoneyReceived() {
      if (this.fuelMoneyInfo && this.fuelMoneyInfo.fuel_money_transactions.length) {
        return this.fuelMoneyInfo.fuel_money_transactions.reduce((acc, transaction) => {
          return acc + transaction.amount
        }, 0)
      }
      return 0
    },

    currentShiftForApproval() {
      return this.shifts.find(shift => shift.available_action === 'approve_open') || null
    },

    shiftsProcessedArray() {
      const result = []
      /**
       * Здесь currentShift - это как бы основная смена,
       * разграничим информацию по ней и по связанной с ней сменой усиления,
       * которая находится в поле gain_info,
       * обозначим это флагом isGain
       */
      this.shifts.forEach(currentShift => {
        const currentShiftInfo = {
          ...currentShift,
          isGain: currentShift.currently_on_gain ? true : false
        }

        delete currentShiftInfo.gain_info

        let gainShiftInfo = null

        if (currentShift.gain_info) {
          /**
           * currentShift.currently_on_gain === true, то в gain_info информация по смене родного производства
           */
          gainShiftInfo = {
            ...currentShift,
            ...currentShift.gain_info,
            isGain: currentShift.currently_on_gain ? false : true,
            isGainInfo: true
          }
        }

        if (currentShift.currently_on_gain) {
          /**
           * Если currentShift.currently_on_gain === true,
           * то тогда сначала пушим информацию из gain_info,
           * так как там информация по смене родного производства,
           * если она есть
           */
          if (gainShiftInfo) {
            result.push(gainShiftInfo)
          }
          result.push(currentShiftInfo)
        } else {
          /**
           * Иначе пушим сначала информацию из currentShift,
           * а потом из gain_info, если она есть
           */
          result.push(currentShiftInfo)
          if (gainShiftInfo) {
            result.push(gainShiftInfo)
          }
        }
      })

      return result
    }
  },

  methods: {
    ...mapActions({
      getCoutierDetail: 'couriers/getCoutierDetail',
      getCourierInventory: 'couriers/getCourierInventory',
      patchCourier: 'couriers/patchCourier',
      createGain: 'couriers/createGain',
      getRouteTaskById: 'routeTasks/getRouteTaskById',
      setActionShift: 'couriers/setActionShift',
      deleteGain: 'couriers/deleteGain',
      deleteShift: 'couriers/deleteShift',
      getShiftPhotos: 'couriers/getShiftPhotos',

      patchFuelTransaction: 'couriers/patchFuelTransaction',
      postFuelTransaction: 'couriers/postFuelTransaction'
    }),

    ...mapMutations({
      setPageLoading: 'pageLoader/SET_LOADING'
    }),

    numberWithSeparator,

    async patchCourierPending() {
      this.patchPending = true
      const is_foot_courier = this.courierType.id === 0 ? true : false
      try {
        await this.patchCourier({
          courier_id: this.courierInfo.courier_id,
          data: {
            is_foot_courier
          }
        })
        this.$emit('courier-changed', {
          courier_id: this.courierInfo.courier_id,
          is_foot_courier
        })
      } finally {
        this.patchPending = false
      }
    },
    getAppNameText(name, isPlatform) {
      if (name) {
        const strArr = name.split('(')
        if (strArr.length === 2) {
          return `${
            isPlatform ? `<b>${strArr[0].trim()}</b>` : strArr[0].trim()
          } (${strArr[1].trim()}`
        }
        return name
      }
      return name
    },

    async setCourierDetailInfo() {
      if (this.courierId) {
        const sendedParams = {
          courier_id: this.courierId
        }
        if (this.current) {
          sendedParams.current = true
        }
        const coutierDetail = await this.getCoutierDetail({
          ...sendedParams
        })
        // const courierIventory = await this.getCourierInventory(this.courierId)
        // console.log(courierIventory);

        this.courierInfo = coutierDetail.courier_info
        if (this.current) {
          this.shifts = coutierDetail.current_shift_info ? [coutierDetail.current_shift_info] : []
        } else {
          this.shifts = coutierDetail.today_shifts ? coutierDetail.today_shifts : []
        }

        this.fuelMoneyInfo = coutierDetail.fuel_money_info
      }
    },

    async show() {
      this.shiftPhotos = []
      await this.setCourierDetailInfo()
      this.courierType = this.courierInfo.is_foot_courier
        ? this.courierTypeOptions[0]
        : this.courierTypeOptions[1]
      if (this.shifts.length) {
        const currentShift = this.shifts.find(shift => shift.is_current)
        if (currentShift) {
          this.currentShift = currentShift
        }
      }

      if (this.fuelMoneyInfo && this.fuelMoneyInfo.fuel_money_transactions.length) {
        this.expandedFuelTable = true
      }

      if (this.shifts.length && this.shifts[0].shift_id) {
        this.fetchShiftPhotos(this.shifts[0].shift_id)
      }

      this.$refs.modal.show()
    },
    onTMCModalOpen() {
      this.$refs['tmc-modal'].show()
    },

    hide() {
      this.expandedFuelTable = false
      this.showCurrentShiftFuelForm = false
      this.currentShift = null
      this.currentShiftFuelSumm = 0
      this.editableFuelTransaction = null
      this.shiftPhotos = []
      this.$refs.modal.hide()
    },
    onSendToGainModalShow() {
      this.$refs['send-to-gain-modal'].show()
    },
    async onSendToGain(event) {
      await this.createGain({
        shift_id: this.currentShift.shift_id,
        data: event
      })
      this.$emit('gain-changed')
    },

    onSubmitFuel() {
      this.$refs['observer-fluent'].validate().then(async success => {
        if (success) {
          if (this.fuelMoneyInfo.transaction_info.transaction_id) {
            this.editableFuelTransaction = {
              transaction_id: this.fuelMoneyInfo.transaction_info.transaction_id
            }

            this.onTransactionChange({
              amount: this.currentShiftFuelSumm
            })
          } else if (this.fuelMoneyInfo.transaction_info.shift_id) {
            const postFuelObject = {
              shift_id: this.fuelMoneyInfo.transaction_info.shift_id,
              courier_id: this.courierInfo.courier_id,
              data: {
                amount: this.currentShiftFuelSumm
              }
            }
            await this.postFuelTransaction(postFuelObject)
            await this.setCourierDetailInfo()
          }
          this.$refs['observer-fluent'].reset()
          this.currentShiftFuelSumm = 0
          this.showCurrentShiftFuelForm = false
        }
      })
    },

    openFuelModal(transaction) {
      this.editableFuelTransaction = transaction
      this.$nextTick(() => {
        this.$refs['fuel-form-modal'].show()
      })
    },

    async onTransactionChange(e) {
      const patchObject = {
        transaction_id: this.editableFuelTransaction.transaction_id,
        courier_id: this.courierInfo.courier_id,
        data: {
          amount: e.amount
        }
      }
      await this.patchFuelTransaction(patchObject)
      await this.setCourierDetailInfo()
    },

    onExpandFuelTable() {
      if (this.fuelMoneyInfo && this.fuelMoneyInfo.fuel_money_transactions.length) {
        this.expandedFuelTable = !this.expandedFuelTable
      }
    },
    onSelectRouteTask(routeTaskId) {
      this.hide()
      this.getRouteTaskById(routeTaskId)
    },
    async onSetActionShift(event) {
      try {
        this.setPageLoading(true)
        await this.setActionShift(event)
        await this.setCourierDetailInfo()
      } finally {
        this.setPageLoading(false)
        this.$emit('courier-shift-change')
      }
    },
    async onDeleteShift(shiftId) {
      try {
        await this.deleteShift(shiftId)
      } finally {
        this.$emit('courier-shift-change')
      }
    },
    async onDeleteGain(shiftId) {
      try {
        await this.deleteGain(shiftId)
      } finally {
        this.$emit('courier-shift-change')
      }
    },

    async fetchShiftPhotos(shiftId) {
      try {
        const res = await this.getShiftPhotos(shiftId)
        this.shiftPhotos = res.photos ? res.photos.filter(photo => photo.url) : []
      } catch (e) {
        this.shiftPhotos = []
      }
    },

    getPhotoLabel(type) {
      const labels = {
        bag_number: 'Номер сумки',
        selfie: 'Селфи',
        vehicle: 'Транспорт'
      }
      return labels[type] || type
    },

    async onOpenShift() {
      if (!this.currentShiftForApproval) return
      try {
        this.setPageLoading(true)
        await this.setActionShift({
          shift_id: this.currentShiftForApproval.shift_id,
          data: { action: 'begin' }
        })
        this.shiftPhotos = []
        this.hide()
      } finally {
        this.setPageLoading(false)
        this.$emit('courier-shift-change')
      }
    },

    async onRejectShift() {
      if (!this.currentShiftForApproval) return
      try {
        this.setPageLoading(true)
        await this.setActionShift({
          shift_id: this.currentShiftForApproval.shift_id,
          data: { action: 'reject' }
        })
        this.shiftPhotos = []
        this.hide()
      } finally {
        this.setPageLoading(false)
        this.$emit('courier-shift-change')
      }
    }
  }
}
